import { Table, Typography } from 'antd';
import type { ColumnsType } from 'antd/es/table';
import type { TableProps } from 'antd';

const { Text } = Typography;

export interface DataTableProps<T> {
  columns: ColumnsType<T>;
  dataSource: T[];
  loading?: boolean;
  rowKey: string | ((record: T) => string);
  rowSelection?: TableProps<T>['rowSelection'];
  pagination?: TableProps<T>['pagination'];
  emptyText?: string;
  onRow?: (record: T) => { onClick?: () => void };
  bordered?: boolean;
  striped?: boolean;
  scroll?: TableProps<T>['scroll'];
  className?: string;
}

function DataTable<T extends object>({
  columns,
  dataSource,
  loading = false,
  rowKey,
  rowSelection,
  pagination,
  emptyText = 'No data',
  onRow,
  bordered = false,
  striped = false,
  scroll,
  className,
}: DataTableProps<T>) {
  const tablePagination: TableProps<T>['pagination'] = pagination
    ? {
        current: pagination.current,
        pageSize: pagination.pageSize,
        total: pagination.total,
        showSizeChanger: true,
        showTotal: (total) => `Total ${total} records`,
        onChange: pagination.onChange,
      }
    : false;

  return (
    <Table<T>
      className={className}
      columns={columns}
      dataSource={dataSource}
      loading={loading}
      rowKey={rowKey}
      rowSelection={rowSelection}
      pagination={tablePagination}
      locale={{ emptyText: <Text type="secondary">{emptyText}</Text> }}
      onRow={onRow}
      bordered={bordered}
      scroll={scroll}
      tableLayout="auto"
      rowClassName={striped ? (_, index) => (index % 2 === 1 ? 'ant-table-row-striped' : '') : undefined}
    />
  );
}

export default DataTable;
